import { render, staticRenderFns } from "./DisplayLinks.vue?vue&type=template&id=e2394baa&scoped=true&"
import script from "./DisplayLinks.vue?vue&type=script&lang=js&"
export * from "./DisplayLinks.vue?vue&type=script&lang=js&"
import style0 from "./DisplayLinks.vue?vue&type=style&index=0&id=e2394baa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2394baa",
  null
  
)

export default component.exports